module.exports = __webpack_public_path__ + "img/r1.d812a2b5.jpg";